// Application Constants
export const APP_NAME = 'FemWellness'
export const APP_DESCRIPTION = "Your Complete Women's Health Journey"

// API Endpoints (for future use)
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api'

// Local Storage Keys (kept for future use if needed)
export const STORAGE_KEYS = {
  THEME_PREFERENCE: 'themePreference',
  LANGUAGE_PREFERENCE: 'languagePreference',
}

// Validation Rules
export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 8,
  NAME_MIN_LENGTH: 2,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_REGEX: {
    LOWERCASE: /(?=.*[a-z])/,
    UPPERCASE: /(?=.*[A-Z])/,
    NUMBER: /(?=.*\d)/,
    SPECIAL_CHAR: /(?=.*[@$!%*?&])/,
  },
}

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  PROFILE: '/profile',
  FITNESS: '/fitness',
  HEALTH_CONSULTATION: '/health-consultation',
  COMMUNITY: '/community',
  EVENTS: '/events',
  SETTINGS: '/settings',
}

// Theme Colors
export const COLORS = {
  PRIMARY: '#e91e63',
  SECONDARY: '#4fc3f7',
  SUCCESS: '#4caf50',
  WARNING: '#ff9800',
  INFO: '#2196f3',
  LIGHT: '#f8f9fa',
  DARK: '#343a40',
}
